export default "\n<!-- loader.component.html -->\n<div class=\"loading\" [hidden]=\"!loading\">\n    Loading...\n</div>\n\n"